// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__26mZF","containerItemsCenter":"Skeleton_containerItemsCenter__1wjmG"};